/**
 * Warstwa API: przycisk „SAP” w kolejce i w oknie zgłoszenia — polecenie właściciela 2026-10-02.
 *
 * Trasa backendu: `POST tickets/{id}/oznacz-sap` (bez ciała). Jednym kliknięciem przenosi zgłoszenie do kategorii
 * „Inne zgłoszenie SAP” w oknie SAP. Odpowiedzi:
 *  • 200 `{ categoryId, categoryName, poprzedniaCategoryId, poprzedniaCategoryName }` — przeniesione,
 *  • 200 `{ juzSap: true }` — zgłoszenie już jest w oknie SAP, nic się nie zmieniło,
 *  • 409 `{ code: "sap_kosz_brak", message }` — w oknie SAP nie ma kategorii docelowej.
 */
export function attach(api) {
    return {
        /** @param {string} ticketId */
        oznaczSap: (ticketId) => api.post(`/tickets/${encodeURIComponent(ticketId)}/oznacz-sap`),
    };
}
